import { render, staticRenderFns } from "./PerItemPricing.vue?vue&type=template&id=74a1384e&scoped=true&"
import script from "./PerItemPricing.vue?vue&type=script&lang=js&"
export * from "./PerItemPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a1384e",
  null
  
)

export default component.exports